/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface WorkflowItemModifiedLog { 
    id?: string;
    workflow_item_id?: string;
    activity_id?: string;
    title?: string;
    modified_object?: string;
    created_at?: Date;
    created_by?: string;
}